import { 
  ArrowUpRightIcon, 
  ArrowRightIcon, 
  ChevronRightIcon, 
  TrashIcon 
} from '@heroicons/react/24/outline'

export const ArrowUpRight = ({ className = "w-4 h-4", ...props }) => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className={className}>
    <path strokeLinecap="round" strokeLinejoin="round" d="m4.5 19.5 15-15m0 0H8.25m11.25 0v11.25" />
  </svg>
)

export const ArrowRight = ({ className = "w-4 h-4", ...props }) => (
  <ArrowRightIcon className={className} {...props} />
)

export const ChevronRight = ({ className = "w-4 h-4", ...props }) => (
  <ChevronRightIcon className={className} {...props} />
)

export const Trash = ({ className = "w-4 h-4", ...props }) => (
  <TrashIcon className={className} {...props} />
)
